import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { percentageFormatter } from '@dnhb/formatters';
import { ResultDetail } from 'shared/components';
import { sortFrtResults } from '../helpers';

const ResultLabel = styled(ResultDetail)(
  ({ theme, isChecked }) => css`
  width: 100%;
  position: relative;
  cursor: pointer;
  
  input {
    opacity: 0;
    position: absolute;

    &:checked + div {
        border-color: ${theme.primaryColor};
        &::before {
          background-color: ${theme.primaryColor};
        }
      }
    }
  > div {
    font-weight: ${isChecked ? '800' : '600'};
  }
`
);

const RadioCircle = styled.div(({ theme }) => css`
    box-sizing: border-box;
    padding: 3px;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    border: 1px solid ${theme.disabledBackgroundColor};
    flex-shrink: 0;

    &::before {
      content: '';
      display: block;
      height: 100%;
      width: 100%;
      border-radius: 50%;
    }
  `
);

const FrtRadioButton = ({ fixed_rate_term, frt, name, onChange }) => {
  const frts = [frt.nhg, frt.without_nhg].filter(item => item); // remove empty
  const { interest_rate, maximum_mortgage, fixed_rate_term: years } = frts.sort(sortFrtResults)[0];

  const isChecked = fixed_rate_term === years;

  return (
    <ResultLabel
      as="label"
      value={Math.round(maximum_mortgage)}
      isChecked={isChecked}
    >
      <input
        type="radio"
        name={name}
        value={years}
        checked={isChecked}
        onChange={onChange}
      />
      <RadioCircle />
      <div css={{ textAlign: 'left', marginLeft: '16px', flexGrow: '1' }}>
        {years} jaar rentevast <strong>{percentageFormatter(interest_rate)}</strong>
      </div>
    </ResultLabel>
  );
};

FrtRadioButton.propTypes = {
  fixed_rate_term: PropTypes.number.isRequired,
  frt: PropTypes.shape({}).isRequired,
  name: PropTypes.string.isRequired,
};

export default FrtRadioButton;
